import { ref as w, reactive as $, computed as a, onMounted as q, openBlock as C, createElementBlock as b, renderSlot as _, normalizeProps as x, guardReactiveProps as j, createElementVNode as o, withModifiers as d, toDisplayString as S, createCommentVNode as B, unref as E } from "vue";
import { createPopper as N } from "@popperjs/core";
import T from "jump.js";
const I = {
  id: "vjt-tooltip",
  "data-hidden": "",
  role: "tooltip"
}, P = ["innerHTML"], M = { class: "vjt-actions" }, V = ["onClick", "textContent"], A = ["textContent", "onClick"], D = ["textContent", "onClick"], H = /* @__PURE__ */ o("div", {
  id: "vjt-arrow",
  "data-popper-arrow": ""
}, null, -1), O = {
  __name: "VTour",
  props: {
    name: {
      type: String,
      default: "default"
    },
    steps: {
      type: Array,
      required: !0
    },
    autoStart: {
      type: Boolean,
      default: !1
    },
    startDelay: {
      type: Number,
      default: 0
    },
    highlight: {
      type: Boolean,
      default: !1
    },
    buttonLabels: {
      type: Object,
      default: () => ({
        next: "Next",
        prev: "Back",
        finish: "Finish",
        skip: "Skip"
      })
    }
  },
  emits: ["onTourStart", "onTourEnd"],
  setup(p, { expose: g, emit: m }) {
    const e = p, r = w(null), t = $({
      currentStep: 0,
      lastStep: null,
      getCurrentStep: a(() => e.steps[t.currentStep]),
      getLastStep: a(() => e.steps[t.lastStep])
    }), h = a(() => e.steps.length - 1), k = a(() => t.currentStep === h.value ? e.buttonLabels.finish : e.buttonLabels.next);
    g({
      startTour: i,
      nextStep: s,
      prevStep: c,
      endTour: u,
      resetTour: L
    });
    async function i() {
      localStorage.getItem("vjt-" + e.name) !== "true" && await setTimeout(() => {
        document.getElementById("vjt-tooltip").removeAttribute("data-hidden"), r.value = N(document.querySelector(`${t.getCurrentStep.target}`), document.getElementById("vjt-tooltip"), {
          placement: `${t.getCurrentStep.placement ? t.getCurrentStep.placement : "top"}`,
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 8]
              }
            }
          ]
        }), e.highlight && v(), m("onTourStart");
      }, e.startDelay);
    }
    function v() {
      var y;
      let n = document.querySelector(`${t.getCurrentStep.target}`), l = document.querySelector(`${(y = t.getLastStep) == null ? void 0 : y.target}`);
      n.classList.add("vjt-highlight"), l != null && n !== l && l.classList.remove("vjt-highlight");
    }
    async function s() {
      if (t.currentStep < h.value) {
        for (t.getCurrentStep.onNext && await t.getCurrentStep.onNext(), t.lastStep = t.currentStep, t.currentStep++; document.querySelector(`${t.getCurrentStep.target}`) === null; )
          t.currentStep++;
        f();
        return;
      }
      u();
    }
    async function c() {
      if (t.currentStep > 0) {
        for (t.getCurrentStep.onPrev && await t.getCurrentStep.onPrev(), t.lastStep = t.currentStep, t.currentStep--; document.querySelector(`${t.getCurrentStep.target}`) === null; )
          t.currentStep--;
        f();
      }
    }
    function u() {
      var n;
      document.getElementById("vjt-tooltip").setAttribute("data-hidden", ""), (n = document.querySelector(".vjt-highlight")) == null || n.classList.remove("vjt-highlight"), r.value.destroy(), localStorage.setItem("vjt-" + e.name, "true"), T(document.body, {
        duration: 500
      }), m("onTourEnd");
    }
    function L() {
      t.currentStep = 0, t.lastStep = 0, localStorage.removeItem("vjt-" + e.name), i();
    }
    async function f() {
      r.value.setOptions({
        placement: `${t.getCurrentStep.placement ? t.getCurrentStep.placement : "top"}`
      }), r.value.state.elements.reference = document.querySelector(`${t.getCurrentStep.target}`), r.value.update(), T(document.querySelector(`${t.getCurrentStep.target}`), {
        duration: 500,
        offset: -100
      }), e.highlight && v(), t.getCurrentStep.onShow && await t.getCurrentStep.onShow();
    }
    return q(() => {
      e.autoStart && i();
    }), (n, l) => (C(), b("div", I, [
      _(n.$slots, "content", x(j({ step: t })), () => [
        o("div", {
          innerHTML: t.getCurrentStep.content
        }, null, 8, P)
      ]),
      _(n.$slots, "actions", x(j({ endTour: u, nextStep: s, prevStep: c, step: t })), () => [
        o("div", M, [
          o("button", {
            type: "button",
            onClick: d(u, ["prevent"]),
            textContent: S(e.buttonLabels.skip)
          }, null, 8, V),
          t.currentStep > 0 ? (C(), b("button", {
            key: 0,
            type: "button",
            textContent: S(e.buttonLabels.prev),
            onClick: d(c, ["prevent"])
          }, null, 8, A)) : B("", !0),
          o("button", {
            type: "button",
            textContent: S(E(k)),
            onClick: d(s, ["prevent"])
          }, null, 8, D)
        ])
      ]),
      H
    ]));
  }
}, G = {
  install: (p, g) => {
    p.component("VTour", O);
  }
};
export {
  G as default
};
